import React from "react";
import { injectIntl } from "react-intl";
import { useLocation } from "react-router-dom";
import { ROUTES } from "../../utils/constants";
import { getScenarioNumByPath } from "../../utils/helpers";
import resumenClinicoVideo from "../../assets/avatares/resumen-clinico.mp4";
import ScenarioBar from "../../components/ScenarioBar";
import Scenario2NextCta from "./Scenario2NextCta";
import "../StartGame.css";
import "./Scenario2.css";

const CHECKLIST = [
	"Varón de 67 años, derivado desde Atención Primaria para valoración hospitalaria.",
	"Síntomas de alarma digestiva baja: sangre en heces, cambio del ritmo intestinal y pérdida de peso (78 kg frente a 84 kg habituales).",
	"En Atención Primaria: anemia compatible con ferropenia; test de sangre oculta en heces positivo en 2 de 3 muestras.",
	"Se deriva para completar el estudio y decidir la actitud diagnóstica-terapéutica.",
];

function Scenario2Context1() {
	const location = useLocation();
	const activeScenario = getScenarioNumByPath(location.pathname);

	return (
		<div className="start-game-page sc2-context-page">
			<div className="start-game-inner start-game-inner--prep5">
				<span className="start-game-badge sg5-badge">
					<span className="start-game-badge-dot" aria-hidden />
					Escenario 2 · Diagnóstico
				</span>

				<div className="sg5-scroll">
					<header className="sg5-hero">
						<h1 className="sg5-title">
							Motivo de consulta y <span className="sg5-title-accent">derivación</span>
						</h1>
					</header>

					<div className="sg5-mosaic">
						<div className="sg5-mosaic-media">
							<div className="sg5-video-shell">
								<div className="start-game-avatar-inner start-game-avatar-inner--silent sg5-video-inner">
									<video autoPlay playsInline preload="auto" aria-hidden>
										<source src={resumenClinicoVideo} type="video/mp4" />
									</video>
								</div>
							</div>
						</div>

						<div className="sg5-mosaic-aside">
							<div className="sg5-aside-card sg5-aside-card--accent">
								<h2 className="sg5-aside-title">Resumen clínico inicial</h2>
								<ul className="sg5-checklist">
									{CHECKLIST.map((text) => (
										<li key={text}>
											<span className="sg5-check-ico" aria-hidden>
												✓
											</span>
											<span>{text}</span>
										</li>
									))}
								</ul>
							</div>
						</div>
					</div>
				</div>

				<div className="sg5-actions">
					<Scenario2NextCta navigateTo={ROUTES.SCENARIO2_CONTEXT2} activeScenario={activeScenario} />
				</div>
			</div>
			<ScenarioBar activeScenario={activeScenario} />
		</div>
	);
}

export default injectIntl(Scenario2Context1);
